/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { BillingEntityUsageV3 } from './billingEntityUsageV3';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { AWSRegionsEnum } from './aWSRegionsEnum';


export interface BillingUsageV3 { 
    orgId?: string;
    serviceName?: VcdsServiceTypeEnum;
    cloudProvider?: CloudProviderEnum;
    cloudRegion?: AWSRegionsEnum;
    reportingEntityUuid?: string;
    reportingEntityVersion?: string;
    reportTime?: Date;
    reportingEntityType?: string;
    reportingEntityUsage?: Array<BillingEntityUsageV3>;
}
export namespace BillingUsageV3 {
}


